import { config } from '@/auth/webconfig';

export function useImageUrl(imagePath: string): string {
  return config.assetsUrl + imagePath;
}
